const MARQUEE = "BASIT LOAY · GRAPHIC DESIGNER · PHOTOSHOP INSTRUCTOR · AI PRODUCT DESIGNER · ";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 pt-10 overflow-hidden">
      <div className="overflow-hidden py-6 select-none">
        <div className="flex whitespace-nowrap marquee">
          {Array.from({ length: 2 }).map((_, i) => (
            <div
              key={i}
              className="font-display text-[10vw] md:text-[7vw] font-semibold tracking-[-0.04em] uppercase text-white/10 pr-10"
            >
              {Array.from({ length: 3 }).map((_, k) => (
                <span key={k} className={k === 1 ? "text-[#FD1843]/30" : ""}>
                  {MARQUEE}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 items-start border-t border-white/5">
        <div>
          <div className="font-display text-2xl font-bold tracking-tighter">
            BL<span className="text-[#FD1843]">.</span>
          </div>
          <p className="text-white/40 text-sm mt-3 max-w-xs leading-relaxed">
            Premium design studio for brands, products, AI-driven advertising
            and design education.
          </p>
        </div>

        <div className="space-y-3">
          <div className="font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase">
            Sitemap
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-white/70 text-sm">
            <a href="#about" className="hover:text-[#FD1843] transition-colors">About</a>
            <a href="#portfolio" className="hover:text-[#FD1843] transition-colors">Work</a>
            <a href="#featured" className="hover:text-[#FD1843] transition-colors">Featured</a>
            <a href="#course" className="hover:text-[#FD1843] transition-colors">Course</a>
            <a href="#contact" className="hover:text-[#FD1843] transition-colors">Contact</a>
          </div>
        </div>

        <div className="md:text-right space-y-3">
          <div className="font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase">
            Studio
          </div>
          <div className="text-white/70 text-sm">Baghdad, IQ · Worldwide</div>
          <div className="text-white/70 text-sm">basitloay7@gmail.com</div>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 border-t border-white/5 flex items-center justify-between font-mono text-[10px] tracking-[0.28em] text-white/30 uppercase">
        <span>© {new Date().getFullYear()} Basit Loay</span>
        <span>Crafted with obsession</span>
      </div>
    </footer>
  );
}
